// src/pages/inadmin/AdminCompaniesPage.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AdminCompaniesPage = () => {
  const [companies, setCompanies] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({ name: '', address: '', tenant_id: '' });
  const navigate = useNavigate();

  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = () => {
    axios
      .get('/inadmin/companies')
      .then((response) => setCompanies(response.data))
      .catch((error) => console.error('Error al obtener compañías:', error));
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setFormData({ name: '', address: '', tenant_id: '' });
    setOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    axios
      .post('/inadmin/companies', formData)
      .then(() => {
        fetchCompanies();
        handleClose();
      })
      .catch((error) => console.error('Error al crear compañía:', error));
  };

  const handleEdit = (id) => {
    navigate(`/inadmin/companies/edit/${id}`);
  };

  const handleDelete = (id) => {
    axios
      .delete(`/inadmin/companies/${id}`)
      .then(() => fetchCompanies())
      .catch((error) => console.error('Error al eliminar compañía:', error));
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <h2>Gestión de Compañías</h2>
        <Button variant="contained" color="primary" onClick={handleOpen}>
          Crear Compañía
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>ID</strong></TableCell>
              <TableCell><strong>Nombre</strong></TableCell>
              <TableCell><strong>Dirección</strong></TableCell>
              <TableCell><strong>Tenant ID</strong></TableCell>
              <TableCell><strong>Acciones</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {companies.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.address}</TableCell>
                <TableCell>{row.tenant_id}</TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => handleEdit(row.id)}
                    sx={{ mr: 1 }}
                  >
                    Editar
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => handleDelete(row.id)}
                  >
                    Eliminar
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            {companies.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No hay compañías registradas.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Diálogo para crear compañía */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Crear Nueva Compañía</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre"
            name="name"
            fullWidth
            variant="standard"
            value={formData.name}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            label="Dirección"
            name="address"
            fullWidth
            variant="standard"
            value={formData.address}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            label="ID de Tenant"
            name="tenant_id"
            fullWidth
            variant="standard"
            value={formData.tenant_id}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleSubmit}>Crear</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AdminCompaniesPage;
